<template lang="pug">
  section.role-list.box-shadow
    wjs-crumbs
    .wjs-search-box
      .wjs-search-title
        h3 筛选条件
      .wjs-search-content
        el-form(inline, :model="filter", ref="searchForm")
          el-form-item
            el-input(placeholder='角色名称', suffix-icon="el-icon-search", @keyup.native.13='search()', v-model='filter.name')
          el-form-item
            el-input(placeholder='角色昵称', suffix-icon="el-icon-search", @keyup.native.13='search()', v-model='filter.nickname')
          el-form-item
            el-select(placeholder="公司名称", v-model="filter.orgId", @change="search()", visible-change="search()")
              el-option(v-for="o in companyList", :value="o.value", :label="o.name", :key="o.value")
          el-form-item
            el-select(placeholder="状态", v-model="filter.enabled", @change="search()")
              el-option(value="_all_", label="全部")
              el-option(value="0", label="禁用")
              el-option(value="1", label="启用")
      .wjs-search-button
        el-button(size="small", type="primary", @click="search()")  搜索
        el-button(size="small", type="primary", @click="clearFilter")  清除
    .wjs-list-content
      .wjs-list-title
        .wjs-list-button
          el-button(type="primary", size="medium", @click="addRole()", v-if="$permit('USER/ROLEMANAGEMENT/CREATE')") 新增
      .wjs-list-table
        el-table(:data='roleList', style='width: 100%', v-if="$permit('USER/ROLEMANAGEMENT/LIST')")
          el-table-column(prop='roleName', label='角色名称')
          el-table-column(prop='roleNickname', label='角色昵称')
          el-table-column(prop='orgNickeName', label='公司名称')
          el-table-column(prop='note', label='备注')
          el-table-column(prop='enabled', label='状态', width='100')
            template(slot-scope="scope")
              span(:class="scope.row.enabled | statusClass") {{scope.row.enabled | statusFormat}}
          el-table-column(label='操作', width='200', fixed="right")
            template(slot-scope="scope")
              .operations
                span(v-if="!scope.row.enabled && $permit('USER/ROLEMANAGEMENT/ENABLED')", @click="startRole(scope.row)") 启用角色
                span(v-if="scope.row.enabled && $permit('USER/ROLEMANAGEMENT/ENABLED')", @click.stop="stopRole(scope.row)") 停用角色
                span(v-if="$permit('USER/ROLEMANAGEMENT/UPDATE')", @click.stop="editRole(scope.row)") 修改角色
                span(v-if="$permit('USER/ROLEMANAGEMENT/MENUPERMISSIONS')", @click.stop="onMenuDialog('PC', scope.row)") 设置PC菜单权限
                //- span(v-if="$permit('USER/ROLEMANAGEMENT/MENU_APP_PERMISSIONS')", @click.stop="onMenuDialog('APP', scope.row)") 设置APP菜单权限
      el-pagination(@size-change='pageSizeChange', @current-change='pageChange', :current-page='parseInt(filter.page)', :page-sizes="page.sizes", :page-size="parseInt(filter.size)", layout='total, sizes, prev, pager, next, jumper', :total='parseInt(page.total)')
    el-dialog(:title="dialog.title", :visible="dialog.show", :before-close="onCloseDialog")
      v-tree(ref="tree", :data="treeData", :multiple="true", :halfcheck="true")
      .dialog-footer
        el-button(type="primary", @click="getMenuAdd") 保存
        el-button(@click="onCloseDialog") 取消
</template>

<script>
import {
  map
} from 'lodash'
import {
  roleUpdateEable,
  roleList,
  roleDelete,
  menuPermissions,
  menuPermissionsUpdate,
  companyList
} from '@/api/user'
import { userTableSearch } from '@/mixins'
import VTree from 'vue-tree-halower'
import 'vue-tree-halower/dist/halower-tree.min.css'

export default {
  mixins: [userTableSearch],
  components: {
    'v-tree': VTree
  },
  filters: {
    statusClass (value) {
      const classMap = {
        1: 'color-green',
        0: 'color-red'
      }
      return classMap[+value] || ''
    },
    statusFormat (value) {
      return value ? '启用' : '禁用'
    }
  },
  data () {
    return {
      roleList: [],
      filter: {
        enabled: '',
        page: 1,
        size: 10,
        name: '',
        nickname: '',
        orgId: '',
        note: ''
      },
      dialog: {
        show: false,
        title: '设置菜单权限'
      },
      treeData: [],
      roleId: '',
      companyList: [],
      scopeType: ''
    }
  },
  created () {
    // 获取公司列表
    this.getCompanyList()
    this.doSearch()
  },
  methods: {
    addRole () {
      this.$router.push({
        name: 'roleForm',
        params: {
          id: 'add'
        }
      })
    },

    pageSizeChange (val) {
      this.filter.size = val
      this.search(true)
    },

    editRole (role) {
      this.$router.push({
        name: 'roleForm',
        params: {
          id: role.id
        }
      })
    },

    startRole (role) {
      this.$confirm(`此操作将启用${role.roleName}, 是否继续?`, '提示', {
        type: 'warning'
      }).then(() => {
        roleUpdateEable({
          id: role.id,
          enabled: 1
        }).then(res => {
          role.enabled = 1
          this.$message.success(`角色${role.roleName}已启用！`)
        })
      }).catch(() => {})
    },

    stopRole (role) {
      this.$confirm(`此操作将停用${role.roleName}, 是否继续?`, '提示', {
        type: 'warning'
      }).then(() => {
        roleUpdateEable({
          id: role.id,
          enabled: 0
        }).then(res => {
          role.enabled = 0
          this.$message.success(`角色${role.roleName}已停用！`)
        })
      }).catch(() => {})
    },

    deleteRole (roleObj) {
      this.$confirm(`此操作将删除${roleObj.roleName}, 是否继续?`, '提示', {
        type: 'warning'
      }).then(() => {
        roleDelete({
          id: roleObj.id
        }).then(res => {
          roleObj.enabled = 0
          this.$message.success(`角色${roleObj.roleName}已删除！`)
        })
      }).catch(() => {})
    },

    doSearch () {
      roleList(this.filter, {
        loadingMaskTarget: '.role-list'
      }).then(res => {
        const data = res.data.data
        this.roleList = data.content
        this.page.total = data.totalElements
      })
    },

    onCloseDialog () {
      this.dialog.show = false
    },

    onMenuDialog (type, row) {
      this.roleId = row.id
      this.dialog.show = true
      this.scopeType = type
      this.treeData = []
      this.dialog.title = `设置${type}菜单权限`
      menuPermissions({
        roleId: row.id,
        scope: type
      }).then(res => {
        this.treeData = res.data.data
        this.handleTree(this.treeData)
        console.log(this.treeData)
      })
    },
    getMenuAdd () {
      const groups = []
      this.$refs.tree.getNodes().forEach((item) => {
        if (item.checked || item.halfcheck) groups.push(item.id)
      })
      menuPermissionsUpdate({
        groups: groups.join(','),
        roleId: this.roleId,
        scope: this.scopeType
      }).then(res => {
        this.$message.success('权限菜单修改成功')
        this.dialog.show = false
        window.location.reload()
      })
    },
    // 获取公司列表
    getCompanyList () {
      companyList().then(res => {
        const { data: { data } } = res
        const arr = map(data, v => {
          return {
            name: v.organizationNickname,
            value: v.id,
            name2: v.organizationName
          }
        })
        arr.unshift({
          name: '全部',
          value: '_all_',
          name2: ''
        })
        this.companyList = arr
      })
    },
    handleTree (tree) {
      tree.forEach(item => {
        if (item.children) {
          this.handleTree(item.children)
          item.checked = !item.children.find(i => !i.checked)
          item.halfcheck = !!item.children.find(i => i.checked || i.halfcheck) && !!item.children.find(i => !i.checked)
        } else {
          item.halfcheck = false
        }
      })
    }
  }
}
</script>
<style type="sass" scoped>
  .dialog-footer {
    text-align: center;
  }
</style>
